import '../scss/style.scss';

document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.main-header-container');
    const submenuItems = document.querySelectorAll('.wp-block-navigation__submenu-container');

    submenuItems.forEach((submenu) => {
        const parentItem = submenu.closest('.wp-block-navigation-item');

        if (parentItem) {
            parentItem.addEventListener('click', (event) => {
                event.stopPropagation();
                const isOpen = parentItem.classList.toggle('submenu-open');

                // Add or remove the class on the header
                if (isOpen) {
                    header.classList.add('submenu-open');
                } else {
                    // Check if any other submenus are still open
                    const openSubmenus = document.querySelectorAll('.wp-block-navigation-item.submenu-open');
                    if (openSubmenus.length === 0) {
                        header.classList.remove('submenu-open');
                    }
                }
            });
        }
    });

    // Close submenu and reset header on click outside
    document.addEventListener('click', () => {
        document.querySelectorAll('.wp-block-navigation-item.submenu-open').forEach((item) => {
            item.classList.remove('submenu-open');
        });
        header.classList.remove('submenu-open');
    });

    // Close submenu when browser loses focus
    window.addEventListener('blur', () => {
        document.querySelectorAll('.wp-block-navigation-item.submenu-open').forEach((item) => {
            item.classList.remove('submenu-open');
        });
        header.classList.remove('submenu-open');
    });
});
// const dropdowns = document.querySelectorAll('.data-dropdown');
// const blackOut = document.getElementById('content-black-out');
//
// let previousActive = null;
// dropdowns.forEach(dropdown => {
//     dropdown.addEventListener('click', (event) => {
//         event.stopPropagation();
//         const element = event.target;
//
//         if (element === previousActive) {
//             adjustActive(element, 'remove');
//             previousActive = null;
//         } else {
//             adjustActive(previousActive, 'remove');
//             adjustActive(element);
//             previousActive = element;
//         }
//     });
// });

// const addClassBasedOnScrollPosition = () => {
//     const scrollPosition = window.scrollY;
//     const targetElement = document.getElementById('block-section--primary-menu-container');
//
//     if (scrollPosition > 47) {
//         targetElement.classList.add('stuck');
//     } else {
//         targetElement.classList.remove('stuck');
//     }
// };
//
// window.onscroll = function () {
//     addClassBasedOnScrollPosition();
// };
// document.addEventListener('DOMContentLoaded', function (event) {
//     addClassBasedOnScrollPosition();
// });

// document.addEventListener('DOMContentLoaded', function () {
//     const burgerIcon = document.getElementById('burger-icon');
//     const navContainer = document.getElementById('nav-main-container');
//     const menuClose = document.getElementById('menu-close');
//
//     burgerIcon?.addEventListener('click', function () {
//         navContainer.classList.add('active');
//     });
//
//     menuClose?.addEventListener('click', function () {
//         navContainer.classList.remove('active');
//         adjustActive(previousActive, 'remove');
//     });
// });

// blackOut.onclick = function () {
//     adjustActive(previousActive, 'remove');
//     previousActive = null;
// };

// const adjustActive = (element, action = 'add') => {
//     if (element instanceof HTMLElement) {
//         const identifier = element.dataset.dropdown;
//         element.classList[action]('active');
//
//         document.body.classList[action]('content-black-out-body-lock');
//
//         if (blackOut) {
//             blackOut.classList[action]('active');
//         }
//
//         const targetElement = document.getElementById('block-section--primary-menu-container');
//         targetElement.classList[action]('active');
//
//         const megaMenuDropdown = document.getElementById('mega-menu-dropdown--' + identifier);
//         if (megaMenuDropdown) {
//             megaMenuDropdown.classList[action]('active');
//             const dropdownElement = megaMenuDropdown.querySelector('#dropdown--' + identifier);
//             if (dropdownElement) {
//                 dropdownElement.classList[action]('active');
//             }
//         }
//     }
// };
